import { useMutation } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { downloadDocumentContent } from "web_myplann/Api/Document/downloadDocumentContent";
import type { OpenDocumentVariables } from "web_myplann/Api/Document/useOpenDocumentMutation";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { sessionState } from "web_myplann/Shared/State/sessionAtom";
import { device } from "web_myplann/Utils/device";
import { HandleDocumentTypes } from "web_myplann/Utils/WebViewModel";

export const useShareDocumentMutation = () => {
	const { token, tokenVerify, authorizationType } = useAtomValue(sessionState);
	const { t } = useResource();

	return useMutation({
		mutationKey: DocumentKeys.transfer,
		mutationFn: async ({
			id,
			fallbackTitle,
		}: OpenDocumentVariables): Promise<void> => {
			const errorMessage = t(Resources.Common.documentOpenFailed);

			const document = await downloadDocumentContent({
				id,
				fallbackTitle,
				token,
				tokenVerify,
				authorizationType,
				errorMessage,
			});

			const response = await device.handleDocument({
				file: {
					base64: document.base64,
					filename: document.filename,
				},
				actionType: HandleDocumentTypes.SHARE,
				mimeType: document.mimeType,
			});

			if (!response.payload.success) {
				throw new Error(errorMessage);
			}
		},
	});
};
